import { CheckIcon, FaceFrownIcon, FaceSmileIcon, TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import Container from "../../../../components/container";
import Icon from "../../../../components/icon";
import IconButton from "../../../../components/icon-button";
import GreetingOccasionImage from "../../../../models/GreetingOccasionImage";
import clsx from "clsx";
import { DeleteButton, IsActiveButton } from "./buttons";
import { useEffect, useState } from "react";
import OccasionCollectionSelector from "./occasion-collection-selector";
import { OccasionCollection } from "../../../../models";

export default function GreetingOccasionImages({images,occasionCollections}:{images:GreetingOccasionImage[],occasionCollections:OccasionCollection[]}){
    const [localImages, setLocalImages] = useState<GreetingOccasionImage[]>(images);
    const staticUrl = process.env.REACT_APP_AWS_URL;
    useEffect(()=>{
        setLocalImages([...images]);
    },[images]);
    const handleSuccess = (image:GreetingOccasionImage) => {
        const index = localImages.findIndex((i)=>i.id === image.id);
        if(index !== -1){
            localImages[index] = image;
        }
        setLocalImages([...localImages]);
    }
    const handleDeleteImage = (image:GreetingOccasionImage) => {
        const index = localImages.findIndex((i)=>i.id === image.id);
        if(index !== -1){
            localImages.splice(index, 1);
        }
        setLocalImages([...localImages]);
    }
    return (
        
        <div className="w-full flex flex-wrap gap-4">
            {localImages.map((image)=>(
                <Container key={image.id} className="card w-64 bg-base-100 shadow-xl relative">
                    <div className="flex items-center justify-center h-80 ">
                        <div className="flex-1 flex items-center justify-center mb-12 contents">
                            {staticUrl && image.fileName ? (
                                <img
                                    className="max-h-full max-w-full object-contain"
                                    src={staticUrl+"/greeting-occasion-images/"+ image.fileName}
                                    alt={image.fileName}
                                />
                            ) : null}
                            <div className="absolute right-0 top-0 px-2 py-1 text-xs text-gray-600 bg-white">{image.id}</div>
                        </div>
                        <div id="footer" className="flex items-center justify-center bg-white h-12 p-1 gap-2 w-full absolute bottom-0 left-0 right-0">
                          
                            {/* <IsComedyButton image={image} onSuccess={handleSuccess}/> */}
                            <OccasionCollectionSelector image={image} occasionCollections={occasionCollections} onSuccess={handleSuccess}/>
                            <IsActiveButton image={image} onSuccess={handleSuccess}/>
                            <DeleteButton image={image} onSuccess={handleDeleteImage}/>
                        </div>
                    </div>
                </Container>
            ))}
        </div>
           
    )
}